import dist from '@/views/distribution/index'

export default {
  path: '/distribution',
  redirect: '/distribution/index',
  name: 'distribution',
  meta: {
    auth: true,
    label: 'Distribuição'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'distribution.index',
    component: dist,
    meta: {
      auth: true,
      label: 'Geral'
    }
  }]
}
